import StickyAlertProps, {
  StickyAlertPropsSchema,
} from '@/modules/alerts/models/sticky-alert-props';

export const NOTIFICATION_STICKY_ALERT_TYPE = {
  NORMAL: 'NORMAL',
} as const;

type ObjectValues<T> = T[keyof T];

export type NotificationStickyAlertType = ObjectValues<typeof NOTIFICATION_STICKY_ALERT_TYPE>;

export interface NotificationStickyAlertOptions {
  body?: string;

  timeoutMs?: number;

  link?: string;

  orderId?: string;
}

/**
 * This is an interface because `defineProps` only works with interfaces.
 */
export interface NotificationStickyAlertPropsSchema extends StickyAlertPropsSchema {
  type: NotificationStickyAlertType;

  title: string;

  options?: NotificationStickyAlertOptions;
}

export default class NotificationStickyAlertProps extends StickyAlertProps
  implements NotificationStickyAlertPropsSchema {
  type: NotificationStickyAlertType;

  title: string;

  options?: NotificationStickyAlertOptions;

  constructor(
    type: NotificationStickyAlertType,
    message: string,
    options?: NotificationStickyAlertOptions,
  ) {
    super();
    this.type = type;
    this.title = message;
    this.options = options;
  }
}
